import { createAction } from 'actions/utils';
import {
    GET_PERMISSIONS_REQUEST,
    GET_PERMISSIONS_SUCCESS,
    GET_PERMISSIONS_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getPermissions() {
    return (dispatch) => {
        dispatch(createAction(GET_PERMISSIONS_REQUEST, {}));
        return Core.permissionsManager
            .getPermissions()
            .then((response) => {
                dispatch(createAction(GET_PERMISSIONS_SUCCESS, response));
            })
            .catch((error) => {
                dispatch(createAction(GET_PERMISSIONS_ERROR, error));
                throw error;
            });
    };
}
